export const SET_SETTINGS = "FEATURES_SET_SETTINGS";
export const CHECK_FEATURE = "CHECK_FEATURE";

export const SetPreBuiltFeatures = (val) => {
	return {
		type: SET_SETTINGS,
		value: val,
	};
};
